<p-progressBar *ngIf="showing$ | async" [style]="{'height': '6px'}" mode="indeterminate"></p-progressBar>
